import { createMandatoryContext } from './utils';
import { StateSetter } from 'types/utils/React';

interface AdminModeContextType {
  isAdminMode: boolean;
  setIsAdminMode: StateSetter<boolean>;
}

const [useAdminModeContext, AdminModeProvider] = createMandatoryContext<AdminModeContextType>();

export { useAdminModeContext, AdminModeProvider };
